module.exports = __webpack_public_path__ + "static/media/RecomendaRioDeJaneiro2.8478ec63.jpg";